import { render, staticRenderFns } from "./GuardNotifications.vue?vue&type=template&id=7249649a&"
import script from "./GuardNotifications.vue?vue&type=script&lang=js&"
export * from "./GuardNotifications.vue?vue&type=script&lang=js&"
import style0 from "./styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports